import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-product-block-skeleton',
  templateUrl: './product-block-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductBlockSkeletonComponent {}
